module.exports = __webpack_public_path__ + "static/media/Touring.b31e2b7b.svg";